const notificationsRoutes = [
  {
    path: '/email-stage-list',
    name: 'EmailStageTemplateList',
    component: () => import(/* webpackChunkName: "auth" */ './pages/email-stage-template-list.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/email-stage-template-edit/:id',
    name: 'EmailStageTemplateEdit',
    component: () => import(/* webpackChunkName: "add-permit-price" */ './pages/email-stage-template-edit.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/manage-outage',
    name: 'ManageOutage',
    component: () => import(/* webpackChunkName: "system-outage" */ './pages/manage-outage-settings.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/job-events-list',
    name: 'JobEventList',
    component: () => import(/* webpackChunkName: "auth" */ './pages/job-event-list.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
  {
    path: '/job-event-edit/:id',
    name: 'JobEventEdit',
    component: () => import(/* webpackChunkName: "add-permit-price" */ './pages/job-event-edit.vue'),
    meta: {
      /** Access to this route is managed on the server no need to specify in the meta */
    },
  },
];

export default notificationsRoutes;
